<div class="grid-headers" [ngClass]="[dataConfig.offsetTop > 0 ? 'header-height-' + dataConfig.offsetTop : '']" nhaTest="grid-headers">
	<div class="grid-columns">
		@for (column of headerConfig.columns; track trackHeaderColumns(column, $index); let columnIndex = $index) {
			@if (!column.isCollapsed) {
				<div
					class="grid-column"
					[ngClass]="[column.pinned ? 'pinned' : '', column.left ? 'left-position-' + (column.left | gridEvalSize: null) : '']"
					[nhaTest]="column.nhaTest"
				>
					@for (row of column.rows; track trackHeaderRows(row, $index); let rowIndex = $index) {
						<div class="grid-row" [nhaTest]="row.nhaTest">
							@for (cell of row.cells; track trackHeaderCells(cell, $index)) {
								<div
									class="grid-cell"
									[attr.cell-height]="cell.height | gridEvalSize: null"
									[attr.cell-width]="cell.width | gridEvalSize: null"
									[ngClass]="[
										(cell.width | gridEvalSize: null) > 0 ? 'cell-width-' + (cell.width | gridEvalSize: null) : '',
										(cell.height | gridEvalSize: null) > 0 ? 'cell-height-' + (cell.height | gridEvalSize: null) : '',
										cell.align ? cell.align : '',
										cell.vAlign ? cell.vAlign : '',
										cell.cellClassSetter ? (cell.cellClassSetter | templateFunc) : ''
									]"
									[nhaTest]="cell.nhaTest"
								>
									<ng-template
										[ngTemplateOutlet]="cell.customTemplate || defaultHeaderCellTemplate"
										[ngTemplateOutletContext]="{ header: cell }"
									></ng-template>

									@if (enableCollapsibleColumns && !column.pinned && rowIndex === 0) {
										<div>
											<button mat-icon-button class="collapse-btn" (click)="expandCollapseColumn(column, columnIndex)">
												<mat-icon>keyboard_double_arrow_left</mat-icon>
											</button>
										</div>
									}
								</div>
							}
						</div>
					}
				</div>
			} @else {
				<div class="grid-column collapsed">
					@for (row of column.rows; track trackHeaderRows(row, $index); let rowIndex = $index) {
						<div class="grid-row">
							<div
								class="grid-cell"
								[attr.cell-height]="row.cells[0].height | gridEvalSize: null"
								attr.cell-width="8px"
								[ngClass]="['cell-height-' + (row.cells[0].height | gridEvalSize: null)]"
							>
								@if (rowIndex === 0) {
									<button
										mat-icon-button
										class="expand-btn"
										[matTooltip]="'Expand ' + row.cells[0].html"
										(click)="expandCollapseColumn(column, columnIndex)"
									>
										<mat-icon>keyboard_double_arrow_right</mat-icon>
									</button>
								}
							</div>
						</div>
					}
				</div>
			}
		}
	</div>
</div>

<div class="grid-data" [ngClass]="[dataConfig.offsetTop > 0 ? 'offset-top-' + dataConfig.offsetTop : '']" nhaTest="grid-data">
	@if (enableVirtualScroll) {
		<virtual-scroller
			#scroll
			[stripedTable]="enableHover"
			[items]="dataItems"
			(vsChange)="virtualScrollChange.next($event)"
			(vsEnd)="virtualScrollEnd.next($event)"
			(vsUpdate)="virtualScrollUpdate.next($event)"
			class="scroll-container"
		>
			<div style="height: 41px">
				<ng-template [ngTemplateOutlet]="dataAreaTemplate" [ngTemplateOutletContext]="{ items: scroll.viewPortItems }"></ng-template>
			</div>
		</virtual-scroller>
	} @else {
		<ng-template [ngTemplateOutlet]="dataAreaTemplate" [ngTemplateOutletContext]="{ items: dataItems }"></ng-template>
	}
</div>

@if (enablePinnedShadow) {
	<div
		class="pinned-column-shadow"
		[ngClass]="[headerConfig.pinnedShadowLeft ? 'show-pinned-shadow left-position-' + (headerConfig.pinnedShadowLeft | gridEvalSize: null) : '']"
	></div>
}

<ng-template #dataAreaTemplate let-items="items">
	<div class="grid-columns">
		<ng-container *ngFor="let item of items; let i = index; trackBy: trackDataItems">
			@if (dataConfig.group && (dataConfig.group.key | gridShowGroupRow: item : i)) {
				<div
					class="group"
					[class.collapsible]="dataConfig.group.collapsible"
					[class.collapsed]="dataConfig.group.collapsible && collapsedGroups().has(getGroupKey(item))"
					[ngClass]="dataConfig.group.groupClassSetter ? (dataConfig.group.groupClassSetter | templateFunc: [item]) : ''"
					[style.height.px]="+dataConfig.group.height | gridEvalSize: null"
					[nhaTest]="dataConfig.group.nhaTest"
				>
					<div>
						<ng-template
							[ngTemplateOutlet]="dataConfig.group.customTemplate || defaultDataGroupTemplate"
							[ngTemplateOutletContext]="{
								group: dataConfig.group,
								item: item,
								collapsed: dataConfig.group.collapsible && collapsedGroups().has(getGroupKey(item)),
								toggleCollapse: toggleGroupCollapse.bind(this, getGroupKey(item))
							}"
						></ng-template>
					</div>
				</div>
			}

			@if (!dataConfig.group?.collapsible || !collapsedGroups().has(getGroupKey(item))) {
				<div
					class="grid-data-row"
					[ngClass]="[
						dataConfig.rowClass ? (dataConfig.rowClass | templateFunc: [item]) : '',
						dataConfig.rowActivator && (dataConfig.rowActivator | templateFunc: [item]) ? 'active' : '',
						dataConfig.rowActivator$ && (dataConfig.rowActivator$ | templateFunc: [item] | async) ? 'active' : '',
						'cell-height-' + dataConfig.dataRowHeight | gridEvalSize: item
					]"
				>
					<ng-container *ngFor="let column of dataConfig.columns; trackBy: trackColumns(item)">
						@if (!column.isCollapsed) {
							<div
								class="grid-column"
								[ngClass]="[column.pinned ? 'pinned' : '', column.left ? 'left-position-' + (column.left | gridEvalSize: null) : '']"
								[nhaTest]="column.nhaTest"
							>
								@if (column.rows | gridEvalRows: item; as rows) {
									<div class="grid-row" *ngFor="let row of rows; trackBy: trackRows(item)" [nhaTest]="row.nhaTest">
										<div
											class="grid-cell"
											*ngFor="let cell of row.cells; trackBy: trackCells(item)"
											[attr.cell-height]="cell.height | gridEvalSize: item"
											[attr.cell-width]="cell.width | gridEvalSize: item"
											[ngClass]="[
												(cell.width | gridEvalSize: item) > 0 ? 'cell-width-' + (cell.width | gridEvalSize: item) : '',
												(cell.height | gridEvalSize: item) > 0 ? 'cell-height-' + (cell.height | gridEvalSize: item) : '',
												cell.align ? cell.align : '',
												cell.vAlign ? cell.vAlign : '',
												cell.cellClassSetter ? (cell.cellClassSetter | templateFunc: [item]) : ''
											]"
											[nhaTest]="cell.nhaTest"
										>
											<ng-template
												[ngTemplateOutlet]="cell.customTemplate || defaultDataCellTemplate"
												[ngTemplateOutletContext]="{ cell: cell, item: item }"
											></ng-template>
										</div>
									</div>
								}
							</div>
						} @else {
							<div class="grid-column collapsed">
								@if (column.rows | gridEvalRows: item; as rows) {
									@for (row of rows; track $index) {
										<div class="grid-row">
											<div class="grid-cell" [attr.cell-height]="row.cells[0].height | gridEvalSize: null" attr.cell-width="8px"></div>
										</div>
									}
								}
							</div>
						}
					</ng-container>
				</div>
			}
		</ng-container>
	</div>
</ng-template>

<ng-template #defaultHeaderCellTemplate let-header="header" let-item="item">
	@if (header.html | gridHtmlIsFunc) {
		<span [innerHTML]="header.html | templateFunc: [item]"></span>
	} @else {
		<span [innerHTML]="header.html"></span>
	}
</ng-template>

<ng-template #defaultDataCellTemplate let-cell="cell" let-item="item">
	@if (cell.html | gridHtmlIsFunc) {
		<span [innerHTML]="cell.html | templateFunc: [item]"></span>
	} @else {
		<span [innerHTML]="cell.html"></span>
	}
</ng-template>

<ng-template #defaultDataGroupTemplate let-group="group" let-item="item">
	@if (group.html | gridHtmlIsFunc) {
		<span [innerHTML]="group.html | templateFunc: [item]"></span>
	} @else {
		<span [innerHTML]="group.html"></span>
	}
</ng-template>
